import {
  BOARDREQUEST,
  GET_PAPER_ID,
  GET_USER_REQUEST,
  HEADERPATH,
  LOADING_START,
  LOADING_STOP,
  LOGINREQUEST,
  LOGOUT,
  MEDIUMREQUEST,
  NOTICEREQUEST,
  RANDOMDATA,
  SELECTEDDATA,
  SEMESTERREQUEST,
  STANDARDREQUEST,
  SUBJECTREQUEST,
  SEMESTERAUTOREQUEST,
  STANDARDAUTOREQUEST,
  SUBJECTAUTOREQUEST,
} from "./actionTypes";

export const ACTIONS = {
  clearLogin: () => ({ type: LOGOUT }),
  startLoading: () => ({ type: LOADING_START }),
  stopLoading: () => ({ type: LOADING_STOP }),
  getLoginData: (params) => ({ type: LOGINREQUEST, params }),
  getBoardData: (params) => ({ type: BOARDREQUEST, params }),
  getMediumData: (params) => ({ type: MEDIUMREQUEST, params }),
  getStandardData: (params) => ({ type: STANDARDREQUEST, params }),
  getSemesterData: (params) => ({ type: SEMESTERREQUEST, params }),
  getSubjectData: (params) => ({ type: SUBJECTREQUEST, params }),

  getAutoStandardData: (params) => ({ type: STANDARDAUTOREQUEST, params }),
  getAutoSemesterData: (params) => ({ type: SEMESTERAUTOREQUEST, params }),
  getAutoSubjectData: (params) => ({ type: SUBJECTAUTOREQUEST, params }),

  getSelectedData: (payload) => ({ type: SELECTEDDATA, payload }),
  getNoticeTitles: (payload) => ({ type: NOTICEREQUEST, payload }),
  getHeaderPath: (params) => ({ type: HEADERPATH, params }),
  getRandomGenerateData: (params) => ({ type: RANDOMDATA, params }),
  GetUserAction: (params) => ({ type: GET_USER_REQUEST, params }),
  GetPaperId: (params) => ({ type: GET_PAPER_ID, params }),
};

